// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Abrt","buttons":"Footer_buttons__d4zh8"};